import { FC, useState, useEffect } from "react";
import "./sectionhero.scss";
import banner from "images/portadaKaraoke.jpg";
import { useNavigate } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";



export interface SectionHero3Props {
  className?: string;
}

const SectionHero3: FC<SectionHero3Props> = ({ className = "" }) => {
  const navigate = useNavigate()
  const reduceMotion = useReducedMotion();

  const handleRedirectReservation = () => {
    navigate("/rooms");
  };

  // Secuencia: apagado -> (cable conecta) -> parpadeo -> encendido en bucle
  const [phase, setPhase] = useState<"off" | "flicker" | "on">(reduceMotion ? "on" : "off");

  useEffect(() => {
    if (reduceMotion) return;
    const t1 = setTimeout(() => setPhase("flicker"), 1550); // al terminar de dibujarse el cable
    const t2 = setTimeout(() => setPhase("on"), 2450); // tras el parpadeo
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [reduceMotion]);

  const textVariants = {
    off: { opacity: 0.22, textShadow: "0 0 0px rgba(168,85,247,0)" },
    flicker: {
      opacity: [0.22, 1, 0.3, 1, 0.55, 1],
      textShadow: [
        "0 0 0px rgba(168,85,247,0)",
        "0 0 20px rgba(216,180,254,0.95), 0 0 46px rgba(168,85,247,0.6)",
        "0 0 3px rgba(168,85,247,0.25)",
        "0 0 20px rgba(216,180,254,0.95), 0 0 46px rgba(168,85,247,0.6)",
        "0 0 8px rgba(168,85,247,0.5)",
        "0 0 18px rgba(216,180,254,0.9), 0 0 42px rgba(168,85,247,0.55)",
      ],
      transition: { duration: 0.9, ease: "easeOut" },
    },
    on: {
      opacity: 1,
      textShadow: [
        "0 0 8px rgba(168,85,247,0.55), 0 0 22px rgba(168,85,247,0.3)",
        "0 0 18px rgba(216,180,254,0.95), 0 0 44px rgba(168,85,247,0.6)",
        "0 0 8px rgba(168,85,247,0.55), 0 0 22px rgba(168,85,247,0.3)",
      ],
      transition: { duration: 2.6, repeat: Infinity, ease: "easeInOut" },
    },
  };

  return (
    <div
      className={`nc-SectionHero3 relative ${className}`}
      data-nc-id="SectionHero3"
      id="container-hero3"
    >
      <div className="absolute z-10 items-center w-full inset-x-0 top-[50%] sm:top-[50%] text-center flex flex-col" >
        <div className="relative inline-flex flex-col items-center">
          {/* Cable de micrófono que se dibuja y se "enchufa" */}
          <svg
            className="pointer-events-none absolute left-0 -top-[55%] h-[80%] w-[48%] overflow-visible"
            viewBox="0 0 300 200"
            fill="none"
            preserveAspectRatio="xMinYMax meet"
            aria-hidden="true"
          >
            <motion.path
              d="M294 8 C 232 30, 274 92, 190 102 C 116 112, 152 38, 78 96 C 42 124, 60 162, 24 184"
              stroke="#a855f7"
              strokeWidth="5"
              strokeLinecap="round"
              style={{ filter: "drop-shadow(0 0 6px rgba(168,85,247,0.75))" }}
              initial={{ pathLength: reduceMotion ? 1 : 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: reduceMotion ? 0 : 1.5, ease: "easeInOut" }}
            />
            {/* Conector / plug que brilla al conectar con la K */}
            <motion.circle
              cx="24"
              cy="184"
              r="8"
              fill="#e9d5ff"
              style={{ filter: "drop-shadow(0 0 9px rgba(216,180,254,0.95))" }}
              initial={{ opacity: reduceMotion ? 1 : 0, scale: 0.3 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: reduceMotion ? 0 : 1.45, duration: 0.3 }}
            />
          </svg>

          <motion.span
            variants={textVariants}
            initial={reduceMotion ? "on" : "off"}
            animate={phase}
            className="logoKaraoke object-cover w-full text-5xl sm:text-7xl lg:text-9xl md:text-8xl text-purple-700 font-pump"
          >
            Karaoke Rooms
          </motion.span>
        </div>
      </div>
      <div className="absolute z-10 inset-x-0 top-[65%] sm:top-[70%] text-center flex flex-col items-center w-[300px] sm:w-full md:w-full lg:w-full xl:w-full mx-auto space-y-4 lg:space-y-5 xl:space-y-8">

        <span className="sm:text-lg md:text-2xl font-semibold text-purple-700">
          Tu Sala privada de Karaoke, para todos los públicos.
        </span>
        <div className="icono-flecha">
          <i className="las la-angle-down"></i>
        </div>

      </div>

      <div className="relative aspect-w-1 aspect-h-1 sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-16 lg:aspect-h-9 xl:aspect-h-8">

        <img
          id="banner"
          className="absolute inset-0 object-cover "
          src={banner}
          alt="hero"
        />
      </div>
      <div className="sm:flex hidden">
        <div className="relleno font-bold">
          <div className="marquee">
            <span>🎵 SALAS PRIVADAS  🎤 MICROFONOS INALÁMBRICOS 🎶 +30.000 CANCIONES 👆🏼PANTALLA TÁCTIL&nbsp;&nbsp;&nbsp;</span>
          </div>
          <div className="marquee marquee2">
            <span>🎵 SALAS PRIVADAS  🎶 +30.000 CANCIONES 👆🏼PANTALLA TÁCTIL&nbsp;&nbsp;&nbsp;</span>
          </div>
        </div>
      </div>
      <div className="sm:hidden flex justify-center items-center">
        <button onClick={handleRedirectReservation} className=" mt-10 h-12 w-[90%] flex justify-center items-center rounded-3xl bg-[#8F00FF] uppercase text-center text-2xl font-bold hover:text-slate-100 text-slate-100">
          reservar sala
        </button>
      </div>


    </div>
  );
};

export default SectionHero3;
